import React from "react";
import gql from "graphql-tag";
import { Query } from '@apollo/client/react/components';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Button from "react-bootstrap/Button";

import LoggedInMenu from "./LoggedInMenu";
import LoadingView from "./LoadingView";
import ErrorView from "./ErrorView";

import ChangePasswordModal from "./ChangePasswordModal";
import OcrProcessDropzone from "./OcrProcessDropzone";
import UploaderButton from "./UploaderButton";
import SearchButton from "./SearchButton";

const GET_ACCOUNT_INFO = gql`
  query accountDetails {
    accountDetails {
      fullNameLine
      email
      dob
      addressStreet
      addressNumber
      addressZip
      addressCity
      addressCountry
    }
  }
`;

interface IMyAccountProps {
  history: any;
}

export default class MyAccount extends React.Component<IMyAccountProps> {
  state: { showModal: boolean; showPasswordModal: boolean };

  constructor(props: any) {
    super(props);
    this.state = { showModal: false, showPasswordModal: false };
  }

  render() {
    return (
      <>
        <LoggedInMenu history={this.props.history} />
        <OcrProcessDropzone
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
        />
        <div className="content-wrapper">
          <Container fluid>
            <Row>
              <Col xs={12} lg={10} className="main">
                <div className="contentheader">
                  <Container fluid>
                    <Row className="align-items-stretch py-3">
                      <Col xs={6} lg={7}>
                        <UploaderButton
                          onClick={() =>
                            this.setState({
                              ...this.state,
                              showModal: true,
                            })
                          }
                        />
                      </Col>
                      <Col xs={6} lg={5}>
                        <SearchButton
                          history={this.props.history}
                        ></SearchButton>
                      </Col>
                    </Row>
                  </Container>
                </div>
                <div className="sitecontent"></div>
                <Container fluid>
                  <Row>
                    <Col xs={12} className="pb-3">
                      <h1 className="underline">
                        <span className="icon-user"> Mein Profil</span>
                      </h1>
                    </Col>
                    <Col xs={12}>
                      <Tabs defaultActiveKey="myaccount" id="account-table">
                        <Tab eventKey="myaccount" title="Meine Daten">
                          <Query query={GET_ACCOUNT_INFO}>
                            {({ loading, error, data }: any) => {
                              if (loading) {
                                return <LoadingView />;
                              }

                              if (error) {
                                return <ErrorView error={error} />;
                              }

                              return (
                                <>
                                  <div className="py-4 px-2">
                                    <h3 className="mb-3">Meine Daten</h3>
                                    <Row>
                                      <Col xs={12}>
                                        <p>
                                          {data.accountDetails.fullNameLine}
                                          <br />
                                          {data.accountDetails.email}
                                          <br />
                                          Geburtsdatum:{" "}
                                          {data.accountDetails.dob}
                                        </p>
                                      </Col>
                                      <Col xs={12}>
                                        <h3 className="mb-3">Adresse</h3>
                                        <p>
                                          {data.accountDetails.addressStreet}{" "}
                                          {data.accountDetails.addressNumber}
                                          <br />
                                          {data.accountDetails.addressZip}{" "}
                                          {data.accountDetails.addressCity}
                                          <br />
                                          {data.accountDetails.addressCountry}
                                        </p>
                                      </Col>
                                      <Col xs={12}>
                                        <h3 className="mb-3">Passwort</h3>
                                        <ChangePasswordModal
                                          show={this.state.showPasswordModal}
                                          onHide={() =>
                                            this.setState({
                                              showPasswordModal: false,
                                            })
                                          }
                                        />
                                        <Button
                                          variant="light"
                                          onClick={() =>
                                            this.setState({
                                              showPasswordModal: true,
                                            })
                                          }
                                        >
                                          Passwort ändern
                                        </Button>
                                      </Col>
                                    </Row>
                                  </div>
                                </>
                              );
                            }}
                          </Query>
                        </Tab>
                      </Tabs>
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}
